import { reactive, watch } from 'vue';
import { useRoute } from 'vue-router';

export default function useEditMode() {
  const route = useRoute(); 
  const state = reactive({
    value: route.query.mode === 'edit',
  });

  watch(
    () => route.query.mode, 
    (newMode) => {
      state.value = newMode === 'edit';  
    },
    { immediate: true }
  );

  return state;
}
